import { DotsThreeOutlineVertical } from '@liveauctioneers/hammer-ui-core/icons';
import { Menu, MenuItem } from '@liveauctioneers/hammer-ui-core/menu';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useCallback } from 'react';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch } from '@/redux/hooks';
import { openExcludeHouseModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import noop from '@/utils/noop';

type Props = {
    'data-testid'?: string;
    excludeByHouseId: (houseId: number) => void;
    isHovering: boolean;
    isMobileView: boolean;
    optionId: number;
};

export const ExcludeFacetMenu = ({
    'data-testid': dataTestId,
    excludeByHouseId,
    isHovering,
    isMobileView,
    optionId,
}: Props) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const showExcludeConfirmation = useCallback(async () => {
        if (isMobileView) {
            excludeByHouseId(optionId);
        } else {
            dispatch(openExcludeHouseModal(optionId));
        }
    }, [dispatch, excludeByHouseId, isMobileView, optionId]);

    return (
        <div
            className="absolute top-2xs right-2xs z-[2] p-0 print:hidden"
            data-testid={dataTestId}
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            <Menu
                menuPlacement={isMobileView ? 'left' : 'right'}
                menuSize="md"
                numberOfColumns={1}
                trigger={
                    <div
                        className="flex cursor-pointer justify-center"
                        data-testid="exclude-facet-menu-trigger"
                    >
                        <DotsThreeOutlineVertical
                            className={cn(
                                // hidden by default on desktop
                                'hidden xsMax:inline-block',
                                // hover styles
                                {
                                    'inline-block': isHovering,
                                }
                            )}
                            color="secondary"
                            size="sm"
                            style="fill"
                        />
                    </div>
                }
            >
                <ShouldLogInContainer runFunction={showExcludeConfirmation}>
                    <MenuItem
                        onClick={noop}
                        /* As long as the translation key doesn't change, we can guarantee that this will be a string */
                        primaryLabel={String(formatMessage(['search_facet_add_exclusion']))}
                    />
                </ShouldLogInContainer>
            </Menu>
        </div>
    );
};
